import workspaceQuery from 'graphql/queries/supplier/SupplierContactAttributeConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/SupplierContactAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/SupplierContactAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/SupplierContactAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/SupplierContactAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/supplier/SupplierContactAttributeConfigFragment.graphql';

const SupplierContactAttributeConfig = {
  type: 'SupplierContactAttributeConfig',
  title: 'Supplier Contact Attributes',
  formTitle: 'Supplier Contact Attribute',
  formUrl: '/Suppliers/ContactAttributeConfig/Details/',
  workspaceUrl: '/Suppliers/ContactAttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'SUPPLIERS_CONTACT_ATTRIBUTES',
};

export default SupplierContactAttributeConfig;
